import styled from 'styled-components/macro';
import { $primary, $secondaryText } from '../../../../../shared';

// TODO: [01-27-2022] Should be refactored to button

export default styled.div`
    color: ${({ $active }) => ($active ? $primary : $secondaryText)};
    cursor: pointer;
`;
